module.exports = "<div [id]=\"identifier\" class=\"googlechart\" [class.resizing]=\"resizing\"></div>"